module.exports = __webpack_public_path__ + "static/media/base_impact_nutrition.52174c6f.png";